export default function showVideo() {

    document.querySelectorAll('.case-study .video-icon').forEach($link => {
        $link.addEventListener('click', event => {
            var parent = $link.parentNode;
            var video = parent.querySelector("iframe");

            let dataSrc = video.getAttribute('data-src');
            if (dataSrc) {
                setTimeout(() => {
                    video.setAttribute('src', dataSrc);
                }, 100);
            }
            parent.classList.add('video-visible');

        });
    });
}
